// extracted by mini-css-extract-plugin
export default {"wrapper":"DiiaSuccessRoute_wrapper","cta":"DiiaSuccessRoute_cta","title":"DiiaSuccessRoute_title","subtitle":"DiiaSuccessRoute_subtitle"};